import { Injectable } from '@angular/core';
@Injectable({
  providedIn:'root'
})

export class Caller {
    parent: string;
    refValue: string;
}
